// extracted by mini-css-extract-plugin
export default {"root":"app-react-sidebar-KubernetesSidebar-KubectlShell-KubectlShellButton-module__root"};